import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import AdminTable from "../../components/AdminTable";
import * as api from "../../services/api";

export default function AdminTools() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [tools, setTools] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authLoading && (!user || user.role !== "admin")) navigate("/");
  }, [user, authLoading, navigate]);

  const fetchTools = () => {
    api.getAdminTools()
      .then((d: any) => setTools(d.tools || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchTools(); }, []);

  const toggleField = async (id: string, field: string, value: number) => {
    if (field === "is_premium") {
      await api.updateAdminTool(id, { is_premium: !Boolean(value) });
    }
    if (field === "is_active") {
      await api.updateAdminTool(id, { is_active: !Boolean(value) });
    }
    fetchTools();
  };

  const columns = [
    { key: "name", label: "Name" },
    { key: "category", label: "Category" },
    { key: "slug", label: "Slug" },
    { key: "is_premium", label: "Premium", render: (v: number, row: any) => (
      <button onClick={() => toggleField(row.id, "is_premium", v)} className={"px-2 py-1 rounded text-xs font-semibold " + (v ? "bg-amber-100 text-amber-800" : "bg-gray-100 text-gray-600")}>
        {v ? "Yes" : "No"}
      </button>
    )},
    { key: "is_active", label: "Active", render: (v: number, row: any) => (
      <button onClick={() => toggleField(row.id, "is_active", v)} className={"px-2 py-1 rounded text-xs font-semibold " + (v ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800")}>
        {v ? "Yes" : "No"}
      </button>
    )},
  ];

  if (loading) return <div className="p-12">Loading...</div>;

  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-10 py-12">
      <h1 className="text-3xl font-bold mb-8">Manage Tools</h1>
      <AdminTable columns={columns} data={tools} />
    </div>
  );
}